import React from "react";
import { Icon, type IconProps } from "@chakra-ui/react";

export function AidSisyphusMountain(props: IconProps) {
  return (
    <Icon width="2027px" height="auto" fill="none" viewBox="0 0 2027 912" {...props}>
      <path
        fill="#2F1D72"
        d="m168.008 725.616 1.056 2.305 5.02-3.925-.363-1.488.541-.933 2.446 1.66-5.851 6.3 4.896-1.236.518-1.761 1.108-.593.469 4.301-8.947 2.315-1.466 7.714 6.721 2.539-4.688 8.696 2.343 2.012-.259.881-5.32-1.408 2.896-7.588-2.351-.623-3.582 13.103 2.471.211.498.575-5.538 2.964-.633-1.876 2.049-10.661-2.021-6.737 2.536-11.355 2.002-1.368-.265-2.729 1.032-1.246 2.682-.049Z"
      />
      <circle cx="206.012" cy="641.365" r="86.988" fill="#33217B" />
      <path
        fill="#12043E"
        d="M1665.36 593.194 1888 710.5 2025.5 912H-.006v-4.377l147.078-139.229 326.684-175.2L1069 0h5l591.36 593.194Z"
      />
      <mask
        id="mountain-2__a"
        width="2027"
        height="912"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
      >
        <path
          fill="#12043E"
          d="M1665.83 593.194 1884.5 710.5 2027 912H.013v-4.377l147.078-139.229 326.685-175.2L1069 0h5l591.83 593.194Z"
        />
      </mask>
      <g mask="url(#mountain-2__a)" opacity=".6">
        <g clipPath="url(#mountain-2__b)" data-figma-skip-parse="true">
          <path
            fill="url(#mountain-2__c)"
            d="M0 0h1000.6v1000.6H0z"
            opacity=".5"
            shapeRendering="crispEdges"
            transform="rotate(90 349.046 1271.974) scale(1.26663)"
          />
          <path
            fill="url(#mountain-2__c)"
            d="M0 0h1000.6v1000.6H0z"
            opacity=".5"
            shapeRendering="crispEdges"
            transform="matrix(0 1.26663 1.26663 0 1621.02 922.928)"
          />
          <path
            fill="url(#mountain-2__c)"
            d="M0 0h1000.6v1000.6H0z"
            opacity=".5"
            shapeRendering="crispEdges"
            transform="matrix(0 -1.26663 -1.26663 0 1621.02 922.928)"
          />
          <path
            fill="url(#mountain-2__c)"
            d="M0 0h1000.6v1000.6H0z"
            opacity=".5"
            shapeRendering="crispEdges"
            transform="rotate(-90 1271.974 -349.046) scale(1.26663)"
          />
        </g>
        <rect
          width="1791.28"
          height="1791.28"
          x="354.398"
          y="922.928"
          data-figma-gradient-fill='{"type":"GRADIENT_DIAMOND","stops":[{"color":{"r":0.31764706969261169,"g":0.38823530077934265,"b":0.22352941334247589,"a":0.0},"position":0.16500000655651093},{"color":{"r":0.25882354378700256,"g":0.10588235408067703,"b":0.69019609689712524,"a":0.11999999731779099},"position":0.70999997854232788},{"color":{"r":0.46274510025978088,"g":0.35686275362968445,"b":0.94117647409439087,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":0.31764706969261169,"g":0.38823530077934265,"b":0.22352941334247589,"a":0.0},"position":0.16500000655651093},{"color":{"r":0.25882354378700256,"g":0.10588235408067703,"b":0.69019609689712524,"a":0.11999999731779099},"position":0.70999997854232788},{"color":{"r":0.46274510025978088,"g":0.35686275362968445,"b":0.94117647409439087,"a":1.0},"position":1.0}],"transform":{"m00":0.0,"m01":-2533.25292968750,"m02":2887.65136718750,"m10":2533.25292968750,"m11":0.0,"m12":-343.69842529296875},"opacity":0.50,"blendMode":"NORMAL","visible":true}'
          rx="9.612"
          transform="rotate(-45 354.398 922.928)"
        />
        <g clipPath="url(#mountain-2__d)" data-figma-skip-parse="true">
          <path
            fill="url(#mountain-2__e)"
            d="M0 0h1000.46v1000.46H0z"
            opacity=".7"
            shapeRendering="crispEdges"
            transform="rotate(90 348.514 1271.446) scale(1.63742)"
          />
          <path
            fill="url(#mountain-2__e)"
            d="M0 0h1000.46v1000.46H0z"
            opacity=".7"
            shapeRendering="crispEdges"
            transform="matrix(0 1.63742 1.63742 0 1619.96 922.932)"
          />
          <path
            fill="url(#mountain-2__e)"
            d="M0 0h1000.46v1000.46H0z"
            opacity=".7"
            shapeRendering="crispEdges"
            transform="matrix(0 -1.63742 -1.63742 0 1619.96 922.932)"
          />
          <path
            fill="url(#mountain-2__e)"
            d="M0 0h1000.46v1000.46H0z"
            opacity=".7"
            shapeRendering="crispEdges"
            transform="rotate(-90 1271.446 -348.514) scale(1.63742)"
          />
        </g>
        <rect
          width="2315.67"
          height="2315.67"
          x="-17.469"
          y="922.93"
          data-figma-gradient-fill='{"type":"GRADIENT_DIAMOND","stops":[{"color":{"r":0.31764706969261169,"g":0.38823530077934265,"b":0.22352941334247589,"a":0.0},"position":0.16500000655651093},{"color":{"r":0.25882354378700256,"g":0.10588235408067703,"b":0.69019609689712524,"a":0.11999999731779099},"position":0.70999997854232788},{"color":{"r":0.46274510025978088,"g":0.35686275362968445,"b":0.94117647409439087,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":0.31764706969261169,"g":0.38823530077934265,"b":0.22352941334247589,"a":0.0},"position":0.16500000655651093},{"color":{"r":0.25882354378700256,"g":0.10588235408067703,"b":0.69019609689712524,"a":0.11999999731779099},"position":0.70999997854232788},{"color":{"r":0.46274510025978088,"g":0.35686275362968445,"b":0.94117647409439087,"a":1.0},"position":1.0}],"transform":{"m00":0.0,"m01":-3274.8483886718750,"m02":3257.3796386718750,"m10":3274.8483886718750,"m11":0.0,"m12":-714.493652343750},"opacity":0.69999998807907104,"blendMode":"NORMAL","visible":true}'
          rx="9.612"
          transform="rotate(-45 -17.469 922.93)"
        />
        <g clipPath="url(#mountain-2__f)" data-figma-skip-parse="true">
          <path
            fill="url(#mountain-2__g)"
            d="M0 0h1000.85v1000.85H0z"
            opacity=".3"
            shapeRendering="crispEdges"
            transform="rotate(90 349.06 1271.98) scale(.89519)"
          />
          <path
            fill="url(#mountain-2__g)"
            d="M0 0h1000.85v1000.85H0z"
            opacity=".3"
            shapeRendering="crispEdges"
            transform="matrix(0 .89519 .89519 0 1621.04 922.92)"
          />
          <path
            fill="url(#mountain-2__g)"
            d="M0 0h1000.85v1000.85H0z"
            opacity=".3"
            shapeRendering="crispEdges"
            transform="matrix(0 -.89519 -.89519 0 1621.04 922.92)"
          />
          <path
            fill="url(#mountain-2__g)"
            d="M0 0h1000.85v1000.85H0z"
            opacity=".3"
            shapeRendering="crispEdges"
            transform="rotate(-90 1271.98 -349.06) scale(.89519)"
          />
        </g>
        <rect
          width="1265.99"
          height="1265.99"
          x="725.852"
          y="922.92"
          data-figma-gradient-fill='{"type":"GRADIENT_DIAMOND","stops":[{"color":{"r":0.31764706969261169,"g":0.38823530077934265,"b":0.22352941334247589,"a":0.0},"position":0.16500000655651093},{"color":{"r":0.25882354378700256,"g":0.10588235408067703,"b":0.69019609689712524,"a":0.11999999731779099},"position":0.70499998331069946},{"color":{"r":0.46274510025978088,"g":0.35686275362968445,"b":0.94117647409439087,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":0.31764706969261169,"g":0.38823530077934265,"b":0.22352941334247589,"a":0.0},"position":0.16500000655651093},{"color":{"r":0.25882354378700256,"g":0.10588235408067703,"b":0.69019609689712524,"a":0.11999999731779099},"position":0.70499998331069946},{"color":{"r":0.46274510025978088,"g":0.35686275362968445,"b":0.94117647409439087,"a":1.0},"position":1.0}],"transform":{"m00":0.0,"m01":-1790.3792724609375,"m02":2516.230957031250,"m10":1790.3792724609375,"m11":0.0,"m12":27.730802536010742},"opacity":0.30000001192092896,"blendMode":"NORMAL","visible":true}'
          rx="9.612"
          transform="rotate(-45 725.852 922.92)"
        />
      </g>
      <path
        fill="url(#mountain-2__h)"
        d="m1665 593 223 117.5L2025.5 912H.02v-4.384l147.07-139.222 326.684-175.2L511.097 556H1628.12l36.88 37Z"
      />
      <defs>
        <linearGradient id="mountain-2__c" x1="0" x2="500" y1="0" y2="500" gradientUnits="userSpaceOnUse">
          <stop offset=".165" stopColor="#516339" stopOpacity="0" />
          <stop offset=".71" stopColor="#421BB0" stopOpacity=".12" />
          <stop offset="1" stopColor="#765BF0" />
        </linearGradient>
        <linearGradient id="mountain-2__e" x1="0" x2="500" y1="0" y2="500" gradientUnits="userSpaceOnUse">
          <stop offset=".165" stopColor="#516339" stopOpacity="0" />
          <stop offset=".71" stopColor="#421BB0" stopOpacity=".12" />
          <stop offset="1" stopColor="#765BF0" />
        </linearGradient>
        <linearGradient id="mountain-2__g" x1="0" x2="500" y1="0" y2="500" gradientUnits="userSpaceOnUse">
          <stop offset=".165" stopColor="#516339" stopOpacity="0" />
          <stop offset=".705" stopColor="#421BB0" stopOpacity=".12" />
          <stop offset="1" stopColor="#765BF0" />
        </linearGradient>
        <linearGradient id="mountain-2__h" x1="1012.76" x2="1012.76" y1="556" y2="912" gradientUnits="userSpaceOnUse">
          <stop offset=".4" stopColor="#12043E" stopOpacity="0" />
          <stop offset="1" stopColor="#12043E" />
        </linearGradient>
        <clipPath id="mountain-2__b">
          <rect
            width="1791.28"
            height="1791.28"
            x="354.398"
            y="922.928"
            rx="9.612"
            transform="rotate(-45 354.398 922.928)"
          />
        </clipPath>
        <clipPath id="mountain-2__d">
          <rect
            width="2315.67"
            height="2315.67"
            x="-17.469"
            y="922.93"
            rx="9.612"
            transform="rotate(-45 -17.469 922.93)"
          />
        </clipPath>
        <clipPath id="mountain-2__f">
          <rect
            width="1265.99"
            height="1265.99"
            x="725.852"
            y="922.92"
            rx="9.612"
            transform="rotate(-45 725.852 922.92)"
          />
        </clipPath>
      </defs>
    </Icon>
  );
}
